import { useState } from 'react';
import { FaSave } from 'react-icons/fa';
import ActionButton from '../ActionButton';

// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface SaveTemplateDialogProps {
    onSave: (name: string) => void;
    onClose: () => void;
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function SaveTemplateDialog({ onSave, onClose }: SaveTemplateDialogProps) {
    const [templateName, setTemplateName] = useState('');

    const handleSave = () => {
        if (templateName.trim()) onSave(templateName.trim());
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-slate-800 rounded-lg p-6 min-w-[400px] shadow-xl"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 className="text-xl font-semibold mb-4 dark:text-gray-100">Salvar Template</h3>
                <input
                    type="text"
                    placeholder="Nome do template"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 dark:bg-slate-700 dark:text-gray-100 mb-4"
                    autoFocus
                />
                <div className="flex gap-2 justify-end">
                    <ActionButton variant="cancel" onClick={onClose}>
                        Cancelar
                    </ActionButton>
                    <ActionButton variant="secondary" onClick={handleSave} icon={<FaSave />}>
                        Salvar
                    </ActionButton>
                </div>
            </div>
        </div>
    );
}
